import { render, staticRenderFns } from "./AttachFile.vue?vue&type=template&id=1f7617b0&lang=pug"
import script from "./AttachFile.vue?vue&type=script&lang=js"
export * from "./AttachFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports